/* global storeeelItems */

import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { closeModal } from '@/helpers/closeModal';
import { updateBanners, clearImageTimer } from '@/helpers/mediaUtils';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { createSlide } from '@/modules/createSlide';
import { groupMoveButton } from '@/modules/parts/desktop/groupMoveButton';
import { renderGroupMoveButtons, groupMoveButtonAction } from '@/modules/actions/desktop/groupMoveButtonAction';
import { activeVideoPlay } from "@/modules/actions/videoControls";
import { checkVolumeButtonState } from "@/helpers/volumeControl";
import { ctaButton } from '@/modules/parts/ctaButton';
import { clickCtaAction } from '@/modules/actions/clickCtaAction';
import { setupAutoPlayNextAction } from '@/modules/actions/desktop/setupAutoPlayNextAction';
import { slideClickNavigateAction } from "@/modules/actions/desktop/slideClickNavigateAction";
import { animateCurrentProgressBar } from "@/modules/actions/headerLineDuration";
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

export const desktopArrowIconsAction = () => {
  // イベントバインド
  document.querySelectorAll('.arrow-icon-parent').forEach(arrow => {
    arrow.addEventListener('click', () => {
      handleArrow( arrow.id === 'arrow-icon-right-parent' ? 'next' : 'prev' );
    });
  });
};

// グループ切り替え時の再描画処理
function reRenderGroup(slideIndex, contents) {
  const swiper   = getSwiperInstance();
  const wrapper  = document.querySelector('.storeeel-swiper-group-wrapper .swiper-wrapper');
  const modal    = document.querySelector('.storeeel-modal');

  wrapper.innerHTML = '';
  contents.forEach(content => wrapper.appendChild(createSlide(content)));
  swiper.update();
  swiper.slideTo(slideIndex);

  const idx = storeeelItems.contentGroups.findIndex(g => g.id === window.iconId);
  window.prevGroup = storeeelItems.contentGroups[idx - 1];
  window.nextGroup = storeeelItems.contentGroups[idx + 1];
  modal.insertAdjacentHTML('beforeend', groupMoveButton());
  renderGroupMoveButtons();
  groupMoveButtonAction();
  slideClickNavigateAction();
  // 進捗バーのアニメーションを開始
  const video = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video');
  if (video) {
    video.addEventListener('loadedmetadata', () => {
      animateCurrentProgressBar(video.duration, slideIndex);
    });
  }
}

// スライドの動画再生
// 引数に次のスライドか前のスライドかを渡す
export const handleArrow = (direction) => {
  const swiper   = getSwiperInstance();

  // 画像タイマーのクリア
  clearImageTimer();

  // 1. 位置更新
  window.moviePosition += (direction === 'next' ? 1 : -1);
  // 2. コンテンツ取得＆モーダル判定
  let contents = navigateMediaItem();
  if (!contents && window.storeeelItems.frame === "circle") return closeModal();
  if (window.storeeelItems.frame === "square" && isTryToMoveNextFromLastSlide(swiper, direction)) {
    // スライドが最後のスライドで、次のスライドに移動しようとした場合
    closeModal();
    return;
  }

  // 3. バナー更新
  updateBanners();

  // 4. グループ切り替え判定
  const isCircle = window.storeeelItems.frame === "circle";
  const isBoundary = direction === 'next' ? window.moviePosition === 0 : window.moviePosition === contents.length - 1;
  if (isCircle && isBoundary) {
    // circleかつ境界のときのみグループ再描画
    reRenderGroup(direction === 'next' ? 0 : contents.length - 1, contents);
    // CTAボタンを再描画
    document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide .slide-media-wrapper').forEach((wrapper, index) => {
      const ctaText = contents[index]?.ctaText || '';
      wrapper.insertAdjacentHTML('beforeend', ctaButton(ctaText));
    });
    clickCtaAction();
  } else {
    // 通常スライド
    swiper[direction === 'next' ? 'slideNext' : 'slidePrev']();
  }

  // 7. スライドの動画再生
  activeVideoPlay();
  // 8. 音量ボタンの状態に応じて動画のミュート変更
  checkVolumeButtonState();
  // 9. 対象の進捗バースタート
  const video = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video');
  const duration = video?.duration || 5;
  animateCurrentProgressBar(duration, window.moviePosition);
  // 10. 動画終了後の次の動画を再生
  setupAutoPlayNextAction();

  // 11. 計測とローカルストレージ保存
  let groupId;
  if (window.storeeelItems.frame === "circle") {
    groupId = window.iconId;
  } else {
    groupId = null;
  }

  // スライド型の最後のスライドから戻った時のcontentsが取得できないため、調査必要
  if (!contents) return;

  trackStoreeelEvent('storeeel_media_asset_view', {
    'storeeel_name':  contents[window.moviePosition].mediaAsset.name,
    'group_id':       groupId,
    'media_id':       contents[window.moviePosition].mediaAsset.id,
    'campaign_id':    window.storeeelItems.id,
  });
  localStorageRepositories.get("mediaView").set(
    contents[window.moviePosition].mediaAsset.id,
    window.storeeelItems.id
  );
}

function isTryToMoveNextFromLastSlide(swiper, direction) {
  return direction === 'next' && swiper.isEnd || direction === 'prev' && swiper.isBeginning;
}
